import {IForm} from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'type',
      type: 'select',
      label: '类型',
      placeholder: '请选择类型',
      rules: {required: true, message: '类型是必选的', trigger: 'blur'},
      options: [
        {title: '公众号', value: 1},
        {title: '视频号', value: 2},
        {title: '服务号', value: 3},
        {title: '订阅号', value: 4}
      ]
    },
    {
      field: 'certifiedStatus',
      type: 'select',
      label: '认证状态',
      placeholder: '请选择认证状态',
      options: [
        {title: '未认证', value: 0},
        {title: '已认证', value: 1}
      ]
    },
    {
      field: 'certifiedEnterprise',
      type: 'input',
      label: '认证企业',
      placeholder: '请输入认证企业',
    },
    {
      field: 'thirdParty',
      type: 'input',
      label: '所属第三方',
      placeholder: '请输入所属第三方',
    },
    {
      field: 'expireTime',
      type: 'datepicker',
      label: '到期时间',
      otherOptions: {
        placeholder: '选择到期时间',
        'value-format': 'YYYY-MM-DD'
      }
    },
    {
      field: 'name',
      type: 'input',
      label: '名称',
      placeholder: '请输入名称名称',
      rules: {required: true, message: '名称是必填的', trigger: 'blur'}
    },
    {
      field: 'liveTeacher',
      type: 'input',
      label: '直播老师',
      placeholder: '请输入直播老师',
    },
    {
      field: 'oaAccount',
      type: 'input',
      label: '账号',
      placeholder: '请输入账号',
      otherOptions: {
        autocomplete: 'off'
      }
    },
    {
      field: 'oaPassword',
      type: 'password',
      label: '密码',
      placeholder: '请输入密码',
      otherOptions: {
        autocomplete: 'new-password'
      }
    },
    {
      field: 'manager',
      type: 'input',
      label: '管理员',
      placeholder: '请输入管理员',
    },
    {
      field: 'remark',
      type: 'textarea',
      label: '备注',
      placeholder: '请输入备注',
    },
  ],
  colLayout: 24,
  itemStyle: {}
}
